module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-713c04971fa258ac1e48a5a13b327876.png";